import errorcard from './ErrorCard';
export default errorcard;
